<template>
  <RFQForm :config="config" />
</template>

<script>
import RFQForm from "../../components/RFQForm/RFQForm.vue";

export default {
  name: "app",
  components: {
    RFQForm
  },
  data() {
    return {
      config: JSON.parse(this.$options._parentVnode.data.props.config)
    };
  }
};
</script>
